export default __webpack_public_path__ + "static/SoumyaSwaminathan-123fa5910499a9b9b5dca3bbe5e52da5.png";